// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v3/get_deactivation.proto

/* oxlint-disable */
import { ApiDeactivationRequestRequirements } from "./deactivation_request_requirements";
import { ApiNoticePeriod, apiNoticePeriodFromJSON, apiNoticePeriodToJSON } from "./notice_period";

/** Describes the request to get the deactivation status for an organization. */
export interface ApiGetDeactivationRequest {
  /** The organization ID (UUID format). */
  readonly organizationId: string;
}

/** Describes the response containing the current deactivation request. */
export interface ApiGetDeactivationResponse {
  /** True if organization is deactivated. */
  readonly deactivated: boolean;
  /** Date when organization was deactivated. Present only when the organization has been deactivated already. */
  readonly deactivationDate?:
    | string
    | null
    | undefined;
  /**
   * Earliest date when the organization is going to be deactivated if requirements are met.
   * Present only when there is an ongoing deactivation request.
   */
  readonly dueDate?:
    | string
    | null
    | undefined;
  /** Organization has an ongoing deactivation request. */
  readonly ongoing: boolean;
  /** Who initiated the deactivation. */
  readonly requester: string;
  /** Requirements for the deactivation to be completed. */
  readonly requirements:
    | ApiDeactivationRequestRequirements
    | null;
  /** Deactivation is related to fraud investigation. */
  readonly fraudRelated: boolean;
  /** Organization has an ongoing downgrade request related to the deactivation request. */
  readonly ongoingDowngrade: boolean;
  /** Notice period of the deactivation */
  readonly noticePeriod?: ApiNoticePeriod | null | undefined;
}

export const ApiGetDeactivationRequest: MessageFns<ApiGetDeactivationRequest> = {
  fromJSON(object: any): ApiGetDeactivationRequest {
    return { organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "" };
  },

  toJSON(message: ApiGetDeactivationRequest): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    return obj;
  },
};

export const ApiGetDeactivationResponse: MessageFns<ApiGetDeactivationResponse> = {
  fromJSON(object: any): ApiGetDeactivationResponse {
    return {
      deactivated: isSet(object.deactivated) ? globalThis.Boolean(object.deactivated) : false,
      deactivationDate: isSet(object.deactivation_date) ? globalThis.String(object.deactivation_date) : null,
      dueDate: isSet(object.due_date) ? globalThis.String(object.due_date) : null,
      ongoing: isSet(object.ongoing) ? globalThis.Boolean(object.ongoing) : false,
      requester: isSet(object.requester) ? globalThis.String(object.requester) : "",
      requirements: isSet(object.requirements)
        ? ApiDeactivationRequestRequirements.fromJSON(object.requirements)
        : null,
      fraudRelated: isSet(object.fraud_related) ? globalThis.Boolean(object.fraud_related) : false,
      ongoingDowngrade: isSet(object.ongoing_downgrade) ? globalThis.Boolean(object.ongoing_downgrade) : false,
      noticePeriod: isSet(object.notice_period) ? apiNoticePeriodFromJSON(object.notice_period) : null,
    };
  },

  toJSON(message: ApiGetDeactivationResponse): unknown {
    const obj: any = {};
    if (message.deactivated !== undefined && message.deactivated !== null) {
      obj.deactivated = message.deactivated;
    }
    if (message.deactivationDate !== undefined && message.deactivationDate !== null) {
      obj.deactivation_date = message.deactivationDate;
    }
    if (message.dueDate !== undefined && message.dueDate !== null) {
      obj.due_date = message.dueDate;
    }
    if (message.ongoing !== undefined && message.ongoing !== null) {
      obj.ongoing = message.ongoing;
    }
    if (message.requester !== undefined && message.requester !== null) {
      obj.requester = message.requester;
    }
    if (message.requirements !== undefined && message.requirements !== null) {
      obj.requirements = ApiDeactivationRequestRequirements.toJSON(message.requirements);
    }
    if (message.fraudRelated !== undefined && message.fraudRelated !== null) {
      obj.fraud_related = message.fraudRelated;
    }
    if (message.ongoingDowngrade !== undefined && message.ongoingDowngrade !== null) {
      obj.ongoing_downgrade = message.ongoingDowngrade;
    }
    if (message.noticePeriod !== undefined && message.noticePeriod !== null) {
      obj.notice_period = apiNoticePeriodToJSON(message.noticePeriod);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
